import React from 'react';
import ContactForm from '../components/ContactForm';

const ContactPage = () => {
  return (
    <div className="min-h-screen">
      <ContactForm isFullPage={true} />
    </div>
  );
};

export default ContactPage; 